<template>
  <div v-show="!boxOpened">
    <video-chat-circle v-if="videoChat.GetCall" class="chat-circle" />
    <div
      v-else
      class="chat-circle"
      @click="$eb.emit('BoxOpen')"
      :style="{
        backgroundColor: $store.state.config.storeId == 59 ? 'white' : '',
        border: $store.state.config.storeId == 59 ? '1px solid black' : ''
      }"
    >
      <!--svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45" class="svg-logo">
        <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 18.136719 20.644531 C 18.136719 21.492188 17.453125 22.179688 16.609375 22.179688 C 15.765625 22.179688 15.078125 21.492188 15.078125 20.644531 C 15.078125 19.796875 15.765625 19.109375 16.609375 19.109375 C 17.453125 19.109375 18.136719 19.796875 18.136719 20.644531 Z M 18.136719 20.644531 "/>
        <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 29.777344 20.644531 C 29.777344 21.492188 29.09375 22.179688 28.25 22.179688 C 27.40625 22.179688 26.722656 21.492188 26.722656 20.644531 C 26.722656 19.796875 27.40625 19.109375 28.25 19.109375 C 29.09375 19.109375 29.777344 19.796875 29.777344 20.644531 Z M 29.777344 20.644531 "/>
        <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 23.957031 20.644531 C 23.957031 21.492188 23.273438 22.179688 22.429688 22.179688 C 21.585938 22.179688 20.902344 21.492188 20.902344 20.644531 C 20.902344 19.796875 21.585938 19.109375 22.429688 19.109375 C 23.273438 19.109375 23.957031 19.796875 23.957031 20.644531 Z M 23.957031 20.644531 "/>
        <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 30.613281 3.804688 L 16.53125 3.804688 C 13.066406 3.804688 10.046875 5.890625 8.789062 9.113281 C 7.65625 12.007812 7.824219 14.550781 8.5 14.53125 C 8.941406 14.523438 8.863281 12.226562 10.363281 9.976562 C 11.238281 8.664062 12.9375 7.0625 16.324219 7.0625 L 30.164062 7.0625 C 33.949219 7.0625 37.027344 9.78125 37.027344 13.121094 L 37.027344 26.601562 C 37.027344 29.941406 33.949219 32.65625 30.164062 32.65625 L 15.53125 32.980469 C 15.425781 32.980469 15.324219 33.003906 15.234375 33.046875 C 15.234375 33.046875 9.316406 35.867188 8.816406 36.03125 C 8.539062 36.125 8.253906 35.910156 8.257812 35.613281 C 8.261719 35.1875 8.390625 34.550781 8.492188 34.019531 L 9.597656 28.125 C 9.660156 27.667969 9.78125 27.296875 9.332031 27.210938 C 8.878906 27.125 8.785156 27.535156 8.671875 27.976562 L 6.128906 36.234375 C 5.816406 37.292969 6.164062 38.097656 6.984375 38.667969 C 7.585938 39.089844 8.199219 39.246094 8.757812 39.183594 C 9.183594 39.132812 9.65625 38.992188 10.039062 38.785156 L 15.191406 36.261719 C 15.539062 36.089844 15.925781 36 16.316406 36 L 30.613281 36 C 35.234375 36 38.980469 32.238281 38.980469 27.59375 L 38.980469 12.210938 C 38.984375 7.570312 35.238281 3.804688 30.613281 3.804688 Z M 30.613281 3.804688 "/>
      </!--svg--> <!-- ancien logo svg-->
      
      <img v-if="$store.state.config.storeId == 43" class="path-svg-logo-cleed-ai" src="https://storage.googleapis.com/cleed-datacenter-europe/Logo_Cleed_v2.png" style="width: 100%; margin-top: 3px;" />
      <img v-else-if="$store.state.config.storeId == 59" src="https://storage.googleapis.com/cleed-datacenter-europe/Formacast/Visuel%20Chat%20gris.png" style="width: 45px; margin: -8px -10px -10px -8px"  />
      <svg v-else-if="$store.state.config.storeId == 20 || $store.state.config.storeId == 54 || $store.state.config.storeId == 78 || $store.state.config.storeId == 79 || $store.state.config.storeId == 89 || $store.state.config.storeId == 90" xmlns="http://www.w3.org/2000/svg" viewBox="3 3 55 55" class="svg-logo">  
        <path class="path-svg-logo" style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M42.81,30.9A8.77,8.77,0,0,0,34,22.13h-7a8.77,8.77,0,1,0,0,17.54h3.51V43s3.79-1.66,5.1-2.36a19.91,19.91,0,0,0,4.38-3.36c.16-.15.31-.3.46-.47s.26-.28.26-.28h0A8.76,8.76,0,0,0,42.81,30.9Zm-15.4,1.46a1,1,0,1,1,1.05-1.05A1,1,0,0,1,27.41,32.36Zm3.34,0a1,1,0,1,1,1.05-1.05A1,1,0,0,1,30.75,32.36Zm3.33,0a1,1,0,1,1,1.05-1.05A1,1,0,0,1,34.08,32.36Z" />
      </svg>
      <svg v-else-if="$store.state.config.storeId == 56" fill="#ffffff" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"  width="30px" height="30px" viewBox="0 0 960.3 960.299" xml:space="preserve" stroke="#ffffff">
        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>
        <g id="SVGRepo_iconCarrier"> <g> <path d="M0,862.281c0,23.4,25.6,37.8,45.6,25.601l156-95.101c9.4-5.7,20.2-8.8,31.2-8.8h667.5c33.101,0,60-26.9,60-60v-596 c0-33.1-26.899-60-60-60H60c-33.1,0-60,26.9-60,60V862.281z"/> </g> </g>
      </svg>
      <svg v-else-if="$store.state.config.storeId == 87" style="margin: -9px 0px 0px -10px;" width="50px" height="50px">       
          <image xlink:href="https://storage.googleapis.com/cleed-datacenter-europe/mfk/circle_logo.svg" src="https://storage.googleapis.com/cleed-datacenter-europe/mfk/circle_logo.svg" width="50" height="50"/>    
      </svg>
      
      <img v-else class="path-svg-logo" src="https://storage.googleapis.com/cleed-datacenter-europe/Logo_Cleed_v2.png" style="width: 100%; margin-top: 3px;"/>


      <span
        id="cleed-notifications"
        class="transition"
        :class="{ 'visible': notification }"
      >{{ number_notif }}</span>

      <span v-if="$store.state.config.chat_config.chat_state.state == 'active' && $store.state.config.storeId != 41 && $store.state.config.storeId != 26 && $store.state.config.storeId != 47 && $store.state.config.storeId != 50" class="green-circle"></span>
      <span v-if="$store.state.config.chat_config.chat_state.state == 'active' && ($store.state.config.storeId == 50)" class="green-circle-right-carven"></span>
      <span v-if="$store.state.config.chat_config.chat_state.state == 'active' && ($store.state.config.storeId == 26 || $store.state.config.storeId == 47)" class="green-circle-left"></span>
    </div>
  </div>
</template>

<script>
const store = require("@/store").default;
import VideoChatCircle from './video/VideoChatCircle.vue'
import { customLogger } from "@/utils";
export default {
  name:"ChatCircle",
  components:{
    VideoChatCircle
  },
  data: () => {
    return {
      green_display: false,
    };
  },
  computed: {
    boxOpened() {
      return store.state.navigation.boxOpened
    },
    notification() {
      return store.state.navigation.notification
    },
    number_notif() {
      const messages = store.state.user.messages
      let counter = 1

      for (let idx = messages.length - 1; idx >= 0; idx--) {
        const msg = messages[idx];
        
        if (msg.sender_type == 'bot')
          ++counter
        else
          break
      }
      return counter
    },
    videoChat() {
      const data = this.$store.state.videoChat;
      return data;
    },
  },
  mounted() {
    // customLogger('mounted stable version circle')
    //on ne veut afficher la pastille verte "green-circle" que de 9h à 2h
    let info = new Date()
    if ((info.getHours() >= 9) || (info.getHours() >= 0 && info.getHours() < 2))
      this.green_display = true;
  }
}
</script>

<style>

.transition {
  opacity: 0;
  transition: opacity 0.3s ease;
}

.transition.visible {
  opacity: 1;
}

</style>